import type { ReactNode } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from '@fluentui/react-components';

export interface IConfirmDialogParams {
  message: ReactNode;
  isModalOpen: boolean;
  hideModal: any;
  onYesClick: any;
}

const ConfirmDialog = (params: IConfirmDialogParams) => {
  return (
    <Dialog
      open={params.isModalOpen}
      onOpenChange={(_, data) => {
        if (!data.open) {
          params.hideModal();
        }
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Are you sure?</DialogTitle>
          <DialogContent>{params.message}</DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={() => {
                params.onYesClick();
              }}
            >
              Yes
            </Button>
            <Button appearance="secondary" onClick={params.hideModal}>
              No
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default ConfirmDialog;
